/* Router than switches between the login screen and the main app layout */
/* Inside the main app layout, there is a nested router to switch between the different main content sections */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Router,
  Route,
  Switch,
} from 'react-router-dom';
import {
  LoginPage,
} from 'AppSrc/core/components/auth/login-page';
import { PrivateRoute } from 'AppSrc/core/components/auth/private-route';
import { AppLayout } from 'AppSrc/core/components/app-layout/app-layout';
import { MainContentRouter } from 'AppSrc/core/components/router/router-main-content';
import { history } from './history';

const AuthRouterDisplay = React.memo(({
  listenToSyncedStorageManagerEvents,
  removeSyncedStorageManagerEvents,
}) => (
  <Router
    basename=""
    history={history}
  >
    <Switch>
      <Route
        path="/login"
        component={(referer) => (
          <LoginPage
            referer={referer}
          />
        )}
      />
      <Route
        path="/token_expired"
        component={(referer) => (
          <LoginPage
            referer={referer}
            tokenExpired
          />
        )}
      />
      <PrivateRoute
        path="/"
        component={() => (
          <AppLayout>
            <MainContentRouter />
          </AppLayout>
        )}
      />
    </Switch>
  </Router>
));


AuthRouterDisplay.propTypes = {
  listenToSyncedStorageManagerEvents: PropTypes.func,
  removeSyncedStorageManagerEvents: PropTypes.func,
};


/* --- AuthRouter Redux-connected container component --- */

// mapDispatchToProps tells the container component how to dispatch actions to the redux store
const mapDispatchToProps = (dispatch, ownProps) => ({
  listenToSyncedStorageManagerEvents: () => {
    // dispatch(initSyncedStorageManagerEventListeners());
  },
  removeSyncedStorageManagerEvents: () => {
    // dispatch(removeSyncedStorageManagerEventListeners());
  },
});

const AuthRouter = connect(
  null,
  mapDispatchToProps,
)(AuthRouterDisplay);

export {
  AuthRouterDisplay,
  AuthRouter,
  history,
};
